<div class="dialog-container page-container">
    <div class="popup-header">
        <div class="header-left">
            <div class="header-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24">
                    <g fill="none" stroke="currentColor" stroke-width="1.5">
                        <path
                            d="M14 5V2h-4v3H7v4h3v3h4V9h3V5zM4.5 22.5L2 20V9c2 0 3.5 1 3.5 3v3m14.032 7.5l2.5-2.5V9c-2 0-3.5 1-3.5 3v3" />
                        <path
                            d="m6.656 19.337l-1.01-1.01c-1.212-1.212-.909-2.727.303-3.94l4.053 4.054V23m7.374-3.663l1.01-1.01c1.212-1.212.91-2.727-.303-3.94l-4.053 4.054V23" />
                    </g>
                </svg>
            </div>
            <div class="header-text">
                <h2 class="header-title">{{ popupTitle }}</h2>
                <p *ngIf="popupSubtitle" class="header-subtitle">{{ popupSubtitle }}</p>
            </div>
        </div>

        <button mat-icon-button class="mat-dialog-close" (click)="closeDialog()">
            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 24 24">
                <path fill="currentColor"
                    d="m12 12.708l-5.246 5.246q-.14.14-.344.15t-.364-.15t-.16-.354t.16-.354L11.292 12L6.046 6.754q-.14-.14-.15-.344t.15-.364t.354-.16t.354.16L12 11.292l5.246-5.246q.14-.14.345-.15q.203-.01.363.15t.16.354t-.16.354L12.708 12l5.246 5.246q.14.14.15.345q.01.203-.15.363t-.354.16t-.354-.16z" />
            </svg>
        </button>
    </div>
    <section mat-dialog-content class="mt-4">
        <form [formGroup]="insurerForm">
            <div class="form-container">
                <!-- FCA Reference Number (FRN) - Key Identifier -->
                <div class="form-row">
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-label>FCA Reference Number (FRN)</mat-label>
                        <input type="text" matInput required formControlName="fcaReferenceNumber" placeholder="123456">
                        <mat-error *ngIf="insurerForm.get('fcaReferenceNumber')?.hasError('required')">
                            FCA Reference Number is required
                        </mat-error>
                        <mat-error *ngIf="insurerForm.get('fcaReferenceNumber')?.hasError('pattern')">
                            FCA Reference Number must be 6 digits
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-label>Trading Name</mat-label>
                        <input type="text" matInput required formControlName="tradingName">
                        <mat-error *ngIf="insurerForm.get('tradingName')?.hasError('required')">
                            Trading Name is required
                        </mat-error>
                    </mat-form-field>
                </div>

                <!-- Address and Website URL -->
                <div class="form-row">
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-label>Address</mat-label>
                        <input type="text" matInput required formControlName="address" placeholder="address">
                        <mat-error *ngIf="insurerForm.get('address')?.hasError('required')">
                            Address is required
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-label>Website URL</mat-label>
                        <input type="url" matInput required formControlName="websiteUrl" placeholder="https://example.com">
                        <mat-error *ngIf="insurerForm.get('websiteUrl')?.hasError('required')">
                            Website URL is required
                        </mat-error>
                        <mat-error *ngIf="insurerForm.get('websiteUrl')?.hasError('pattern')">
                            Please enter a valid URL starting with http:// or https://
                        </mat-error>
                    </mat-form-field>
                </div>

                <!-- Key Contact Information -->
                <div class="form-row">
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-label>Contact Person</mat-label>
                        <input type="text" matInput required formControlName="contactPerson">
                        <mat-error *ngIf="insurerForm.get('contactPerson')?.hasError('required')">
                            Contact Person is required
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-label>Contact Email</mat-label>
                        <input type="email" matInput required formControlName="contactEmail">
                        <mat-error *ngIf="insurerForm.get('contactEmail')?.hasError('required')">
                            Contact Email is required
                        </mat-error>
                        <mat-error *ngIf="insurerForm.get('contactEmail')?.hasError('email')">
                            Invalid email address
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="form-row">
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-label>Contact Phone</mat-label>
                        <input matInput formControlName="contactPhone" required placeholder="+4423208792">
                        <mat-error *ngIf="insurerForm.get('contactPhone')?.hasError('required')">
                            Contact Phone is required
                        </mat-error>
                        <mat-error *ngIf="insurerForm.get('contactPhone')?.hasError('pattern')">
                            Invalid phone number format (e.g.,  +44 117 2345678)
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-label>Active Start Date</mat-label>
                        <input matInput [matDatepicker]="startDatePicker" formControlName="activeStartDate" [min]="today">
                        <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #startDatePicker></mat-datepicker>
                        <mat-error *ngIf="insurerForm.get('activeStartDate')?.hasError('required')">
                            Active Start Date is required
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="form-row">
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-label>Active End Date (Optional)</mat-label>
                        <input matInput [matDatepicker]="endDatePicker" formControlName="activeEndDate">
                        <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #endDatePicker></mat-datepicker>
                        <mat-error *ngIf="insurerForm.get('activeEndDate')?.hasError('invalidEndDate')">
                            End date must be after start date
                        </mat-error>
                    </mat-form-field>
                    <div class="form-field"></div> <!-- Empty field for layout -->
                </div>

                <!-- Logo Upload Section -->
                <div class="form-row">
                    <div class="form-field" style="flex: none;">
                        <div class="fileupload-container d-flex" style="flex-direction: column;" appDnd
                            (fileDropped)="isDismissable ? '': onFileDropped($event)">

                            <!-- File Upload Section -->
                            <input type="file" [multiple]="false" #fileDropRef id="fileDropRef"
                                (click)="onFileInputClick()" (change)="onAssetImage($event.target)"
                                [disabled]="isDismissable" accept="image/*" />

                            <!-- Preview Section -->
                            <div *ngIf="imagePreviewUrl" class="preview-box">
                                <img [src]="imagePreviewUrl" alt="Logo Preview"
                                    style="max-width: 100%; height: 100%; object-fit: cover; border-radius: 8px;">
                            </div>

                            <div *ngIf="!imagePreviewUrl">
                                <span class="mb-2 fs-11">Drag and drop company logo here or click to upload</span>
                            </div>
                        </div>
                    </div>
                </div>

                <p> <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 256 256">
                        <g fill="#0075C9">
                            <path d="M176 128a48 48 0 1 1-48-48a48 48 0 0 1 48 48" opacity="0.2" />
                            <path d="M140 128a12 12 0 1 1-12-12a12 12 0 0 1 12 12" />
                        </g>
                    </svg>Map the insurers you want to send the applicant to process*</p>

                <div class="user-cards-grid">
                    @if(adminInsurerList.length > 0){

                    <div *ngFor="let user of adminInsurerList" class="user-card"
                        [class.selected]="selectedProviderIds.includes(user.id)" (click)="selectProvider(user)"
                        [@userCardAnimation]="selectedProviderIds.includes(user.id) ? 'selected' : 'unselected'">
                        <div class="card-content-wrapper">
                            <div class="user-avatar">
                                @if(user.imgLogoUrl){
                                <img [src]="user.imgLogoUrl">
                                }
                                @else{
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                                    <g fill="none" stroke="#0075C9" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-width="1.5">
                                        <path d="M2 22h20M18 9h-4c-2.482 0-3 .518-3 3v10h10V12c0-2.482-.518-3-3-3" />
                                        <path
                                            d="M15 22H3V5c0-2.482.518-3 3-3h6c2.482 0 3 .518 3 3v4M3 6h3m-3 4h3m-3 4h3m9-1h2m-2 3h2m-1 6v-3" />
                                    </g>
                                </svg>
                                }
                            </div>
                            <div class="user-info-text">
                                <p class="fs-12" style="margin: 0;">
                                    {{ user.organisationName}}
                                </p>
                                <p class="fs-12" style="margin: 0;">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                                        <path fill="#0075C9"
                                            d="M12 23C6.443 21.765 2 16.522 2 11V5l10-4l10 4v6c0 5.524-4.443 10.765-10 12M4 6v5a10.58 10.58 0 0 0 8 10a10.58 10.58 0 0 0 8-10V6l-8-3Z" />
                                        <circle cx="12" cy="8.5" r="2.5" fill="#0075C9" />
                                        <path fill="#0075C9"
                                            d="M7 15a5.78 5.78 0 0 0 5 3a5.78 5.78 0 0 0 5-3c-.025-1.896-3.342-3-5-3c-1.667 0-4.975 1.104-5 3" />
                                    </svg>
                                    {{ user.firstName }} {{ user.lastName }}
                                </p>
                            </div>
                        </div>
                    </div>
                    }
                    @else {
                    <div class="card-content-wrapper mt-2">
                        <div class="d-flex justify-content-center align-items-center h-100 w-100">
                            No matches found.
                        </div>
                    </div>
                    }
                </div>


            </div>
        </form>
    </section>
    <section mat-dialog-actions class="d-flex justify-content-end">
        <div class="d-flex gap-2">
            <button class="secondaryBtn" (click)="closeDialog()">
                <span class="btnContent">Cancel</span>
            </button>
            <button class="primaryBtn" (click)="onsubmit()" [disabled]="isSubmitLoading || insurerForm.invalid">
                <span class="btnContent">
                    Submit
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24"
                        *ngIf="isSubmitLoading">
                        <path fill="none" stroke="#ffffff" stroke-linecap="round" stroke-width="1.5"
                            d="M12 6.99998C9.1747 6.99987 6.99997 9.24998 7 12C7.00003 14.55 9.02119 17 12 17C14.7712 17 17 14.75 17 12">
                            <animateTransform attributeName="transform" attributeType="XML" dur="1.26s" from="0,12,12"
                                repeatCount="indefinite" to="360,12,12" type="rotate" />
                        </path>
                    </svg>
                </span>
            </button>
        </div>
    </section>
</div>
